import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Player } from '../models/Player';
import { firstValueFrom } from 'rxjs';
import { ConfigurationService } from './configuration.service';
import { CreatePlayerRequest } from '../models/createPlayerRequest';

@Injectable({
  providedIn: 'root'
})
export class PlayerService {

  constructor(private http:HttpClient, private configService:ConfigurationService) { 
      this.baseUrl = this.configService.getApiEndpoint();
    }
  
    baseUrl:string;

    async searchPlayers():Promise<Array<Player>> {
      let endpoint = `${this.baseUrl}/players`;
      let result = await firstValueFrom(this.http.post<Player[]>(endpoint, {}));
      return result;
    }

    async createPlayer(request:CreatePlayerRequest):Promise<number> {
      let endpoint = `${this.baseUrl}/player`;
      let result = await firstValueFrom(this.http.post<number>(endpoint, request));
      return result;
    }

    async updatePlayer(request:Player):Promise<number> {
      let endpoint = `${this.baseUrl}/player`;
      let result = await firstValueFrom(this.http.patch<number>(endpoint, request));
      return result;
    }
}
